import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { axiosGetData } from "@shared/api/clients";
import { getOperationalModuleSlug } from "./operationalModuleSlugs";
import { OperationalStructure } from "./AccessibleStructures.types";

// Estruturas que o usuário logado pode operar (capacidade `view`) no módulo
// operacional indicado. Endpoint por módulo: GET /v1/<slug>/accessible-structures
// (contrato: docs/prd/operational-modules/operational-modules-endpoints.md §4); o
// `slug` vem do mapa canônico em operationalModuleSlugs.ts. Sem catálogo X.Y.Z
// próprio nesta fatia: 401 (sessão inválida) é tratado globalmente pelo
// unauthorizedHandler do axios; os loaders mapeiam 401 → /login.
export const getAccessibleStructures = async (
  moduleKey: string,
): Promise<OperationalStructure[]> => {
  const slug = getOperationalModuleSlug(moduleKey);
  if (!slug) return [];
  return axiosGetData<OperationalStructure[]>(
    `v1/${slug}/accessible-structures`,
  );
};

// Opções compartilhadas entre o hook (useQuery) e o loader (ensureQueryData), para
// que ambos usem a MESMA chave de cache por módulo.
export const accessibleStructuresQueryOptions = (moduleKey: string) => ({
  queryKey: ["operational", moduleKey, "accessible-structures"] as const,
  queryFn: () => getAccessibleStructures(moduleKey),
});

export const useAccessibleStructuresQuery = (
  moduleKey: string,
  options?: Partial<UseQueryOptions<OperationalStructure[], AxiosError>>,
) => {
  return useQuery<OperationalStructure[], AxiosError>({
    ...accessibleStructuresQueryOptions(moduleKey),
    retry: false,
    throwOnError: false,
    ...options,
  });
};
